import {createAction} from "@reduxjs/toolkit";
import * as types from '../../actionTypes';

export const botPhone = createAction(types.BOT_PHONE, (bot: string) => ({
    payload: bot,
}));
